// extracted by mini-css-extract-plugin
module.exports = {"OuterSVG":"PeopleIcon_OuterSVG__Djqic","SubNavLabel":"PeopleIcon_SubNavLabel__3le2v"};